import styled from '@emotion/styled'
import { AnimatedDiv } from '../animatedDiv/animatedDiv.styles'

export const SimpleMenuContainer = styled(AnimatedDiv)<{
    openLeft?: boolean
    top?: number
    left?: number
    menuPosition?: 'absolute' | 'fixed'
}>`
    position: ${({ menuPosition }) => menuPosition || 'absolute'};
    border-radius: 6px;
    background-color: var(--color-simple-menu);
    z-index: ${({ menuPosition }) => (menuPosition === 'fixed' ? 1000 : 0)};
    padding: 15px 20px;
    box-shadow: 1px 1px 20px 2px rgba(0, 0, 0, 0.2);
    width: max-content;
    min-width: 200px;
    transform: ${({ openLeft }) => (openLeft ? 'translateX(-100%)' : 'none')};
    max-height: 500px;
    overflow-y: auto;
    top: ${({ top }) => `${top}px`};
    left: ${({ left }) => `${left}px`};
`

export const SimpleMenuActivator = styled('span')<{ disabled?: boolean }>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`
